// For clarity, imports are ordered according to flow (order in which the pages are viewed)

import Introduction      from "./pages/Introduction.vue";
import Order             from "./pages/Order.vue";
import Recap             from "./pages/Recap.vue";
import Coords            from "./pages/Coords.vue";
import Confirmation      from "./pages/Confirmation.vue";
import PrintConfirmation from "./pages/PrintConfirmation.vue";
import Privacy           from "./pages/Privacy.vue";

const routes =
          [
              {
                  path     : "/",
                  redirect : "/fr/cartes-cadeaux/introduction",
              },
              {
                  path     : "/fr",
                  redirect : "/fr/cartes-cadeaux/introduction",
              },
              {
                  path     : "/en",
                  redirect : "/en/gift-cards/introduction",
              },
              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(introduction)",

                  name      : "Introduction",
                  component : Introduction,
              },

              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(confidentialite|privacy)",
                  name      : "Privacy",
                  component : Privacy,
              },


              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(commande|order)",
                  name      : "Order",
                  component : Order,
              },



              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(recapitulatif|recap)",
                  name      : "Recap",
                  component : Recap,
              },

              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(coordonnees|coords)",
                  name      : "Coords",
                  component : Coords,
              },

              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(confirmation)",
                  name      : "Confirmation",
                  component : Confirmation,
              },

              {
                  path      : "/:lang/:meaningless(cartes-cadeaux|gift-cards)/:section(confirmation)/:uuid",
                  name      : "PrintConfirmation",
                  component : PrintConfirmation,
              },
          ]


export default routes;
